import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class UpsiMasterService {

  constructor( private httpService: HttpService) { }
  addItem(item) {
    var request = {
        URL: "master/add",
        DATA: item
    }
    console.log("request",request)
    return this.httpService.post(request);        
}

getList(companyDetails){
  var request = {
      URL: "master/list",
      DATA: companyDetails
  }
  return this.httpService.post(request);
}

editItem(ItemId: string) {

  var request = {
      URL: 'master/edit/' + ItemId
  }
  return this.httpService.get(request);
}

delete(id:string){
  var request = {
    URL: "master/delete/"+id,
  
}
return this.httpService.get(request);
}

}
